module.exports = __webpack_public_path__ + "media/theme/zigzag--black-ddee6e2c.png";